import { render, staticRenderFns } from "./SNotificationList.vue?vue&type=template&id=3971e2a8&scoped=true&"
import script from "./SNotificationList.vue?vue&type=script&lang=js&"
export * from "./SNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./SNotificationList.vue?vue&type=style&index=0&id=3971e2a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3971e2a8",
  null
  
)

export default component.exports